/*=========================================================================================
  File Name: moduleDocumentUploadState.js
  Description: DocumentUpload Module State
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
  documenttypes: [],
};
